{
	"title": "Έργα",
	"table": {
		"reference": "Αναφορά",
		"quantity": "Συνολική ποσότητα",
		"savings": "Συνολικές μειώσεις άνθρακα",
		"fetchError": "Δεν ήταν δυνατή η ανάκτηση έργων"
	},
	"showProjectsHistoryTitle": "Εμφάνιση ιστορικού έργων",
	"noProjects": {
		"createDeclaration": "Δημιουργήστε την πρώτη σας δήλωση",
		"description": "Μπορείτε να δημιουργήσετε δηλώσεις για ένα ή περισσότερα υλικά κάνοντας κλικ στο «Δημιουργία δήλωσης»."
	}
}
